import { useEffect } from 'react';
import { scroller } from 'react-scroll';

const useScrollToTop = () => {
    useEffect(() => {
        // Scroll to top when the component is mounted
        scroller.scrollTo('top', {
            duration: 800, // Duration of the scroll in ms
            delay: 0, // Delay before starting the scroll
            smooth: 'easeInOutQuart', // Scroll easing function
        });
    }, []);
};

export default useScrollToTop;